import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {storageCarsStatus} from '../../../common/dictionaries/classification';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';

class StoragePending extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.StoragePendingCarsList,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.emptyStoragePendingCarsValues();
    this.props.fetchStoragePendingCars();
  }

  storagePendingList() {
    const {loading, storagePendingCarsList} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return storagePendingCarsList.map((element, index) => {
      const status = element.status ? element.status : 'empty';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.insertionUser}</Table.Cell>
          <Table.Cell textAlign='center'>{element.storageCar}</Table.Cell>
          <Table.Cell textAlign='center'>{element.invoice}</Table.Cell>
          <Table.Cell textAlign='center'>
            {storageCarsStatus[status]}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <div className='storage-pending'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Coches Pendientes</h2>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Coche</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.storagePendingList()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.storagePending.loading,
    'storagePendingCarsList': state.storagePending.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchStoragePendingCars, emptyStoragePendingCarsValues, navigateTo} =
  Actions;

export default connect(mapStateToProps, {
  fetchStoragePendingCars,
  emptyStoragePendingCarsValues,
  navigateTo,
})(StoragePending);
